// Enum with values
export enum ProblemTypeQuestionValue {
	TrappedContact = 'Trapped or Contact',
	PowerLine = 'Wire Downed or Within Reach (Power Line Problem)',
	Power = 'Power Problem',
	Hazard = 'Hazard',
	Equipment = 'Equipment Problem',
	Tree = 'Tree',
	Pole = 'Pole Debris Left Behind',
}
